import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Table, message } from 'antd';
import { UserOutlined, TeamOutlined, MedicineBoxOutlined, FileTextOutlined } from '@ant-design/icons';
import { superAdminService } from '../../services';
import { useTranslation } from 'react-i18next';

const SuperAdminDashboard = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await superAdminService.getOverviewReport();
            setData(response.data);
        } catch (error) {
            message.error(error.response?.data?.message || t('error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1>{t('dashboard')}</h1>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title={t('totalDoctors')}
                            value={data?.totalDoctors || 0}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#3f8600' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title={t('totalSecretaries')}
                            value={data?.totalSecretaries || 0}
                            prefix={<TeamOutlined />}
                            valueStyle={{ color: '#1890ff' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title={t('totalPatients')}
                            value={data?.totalPatients || 0}
                            prefix={<MedicineBoxOutlined />}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title={t('totalVisits')}
                            value={data?.totalVisits || 0}
                            prefix={<FileTextOutlined />}
                            valueStyle={{ color: '#722ed1' }}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default SuperAdminDashboard;
